// Envision - update free shipping message countdown when cart is updated via AJAX
$(function() {
  var free_shipping_element = $('.announcement-bar.free-shipping-countdown[data-shipping-value]');
  
  function updateFreeShipping(cart_total) {
    if (free_shipping_element.length) {
      var shipping_value = free_shipping_element.data('shipping-value');
      var cart_value = cart_total;
      var amount_remaining = shipping_value - cart_value;

      // update free shipping amount remaining
      $('.free-shipping-countdown-notqualified .shipping_value_left', free_shipping_element).text(Shopify.formatMoney(amount_remaining, Shopify.money_format));

      // hide or show default, notqualified, or qualified elements
      if (cart_value > 0 && amount_remaining > 0) {
        $('.free-shipping-countdown-message', free_shipping_element).addClass('hidden');
        $('.free-shipping-countdown-notqualified', free_shipping_element).removeClass('hidden');
      } else if (cart_value > 0 && amount_remaining <= 0) {
        $('.free-shipping-countdown-message', free_shipping_element).addClass('hidden');
        $('.free-shipping-countdown-qualified', free_shipping_element).removeClass('hidden');
      } else {
        $('.free-shipping-countdown-message', free_shipping_element).addClass('hidden');
        $('.free-shipping-countdown-default', free_shipping_element).removeClass('hidden');
      }
    }
  }
  
  if (free_shipping_element.length) {
    $(document).ajaxComplete(function( event, xhr, settings ) {
      if (settings && (settings.url === "/cart/add.js" || settings.url === "/cart/change.js" || settings.url === "/cart/update.js" || settings.url === "/cart/clear.js")) {
        $.getJSON( "/cart.js", function( response ) {
          if (typeof response.total_price != null) {
            updateFreeShipping(response.total_price);
          }
        });
      }
    }); 
  }
});